import { ApiService } from '../ApiService';
import type {
  JournalSequence,
  UpdateJournalSequenceConfiguration,
} from '../../../types/journal-sequences';

/**
 * Endpoints de configuration des séquences de numérotation des pièces.
 * Source backend: `apps/accounting-service/src/modules/journals/controllers/sequences.controller.ts`
 */
export const journalSequencesApi = {
  /**
   * GET /journal-sequences
   * Liste les séquences configurées pour l'entreprise courante.
   * Filtre optionnel par exercice fiscal.
   */
  list: (params?: { fiscalYearId?: string }) =>
    ApiService.get<{ success: boolean; data: JournalSequence[] }>(
      '/journal-sequences',
      params,
    ),

  /**
   * PATCH /journal-sequences/:id
   * Met à jour le préfixe et/ou le padding d'une séquence.
   * Le compteur courant n'est volontairement pas modifiable depuis l'API
   * pour préserver l'intégrité chronologique.
   */
  update: (id: string, payload: UpdateJournalSequenceConfiguration) =>
    ApiService.patch<{ success: boolean; data: JournalSequence }>(
      `/journal-sequences/${id}`,
      payload,
    ),
};
